import * as React from "react";
import { BuilderContext, useDrawer } from "react-flow-builder";
import { useForm, useFieldArray, useWatch } from "react-hook-form";
import { Text, Grid, Button, Modal, ActionIcon, Title, Divider } from "@mantine/core";
import { IconPlus, IconTrash } from "@tabler/icons-react";

import { CTextInput, CSelect, CMultiSelect, CRadioGroup } from "@supportinitiative/react-hook-form-mantine";

import { ReconsetCVMContext } from "../../ReconsetCVM";
import { getLinkagesLOV, operators, getSystemStatus, getConfirmationStatus } from "../../ReconsetUtils";
import Query from "./Query";
import { object, string, number, date, array, setLocale } from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Where from "./Where";
import { ValueValidationActionSchema, ValueValidationActionType } from "@supportinitiative/common";

function ValueValidation() {
  const { selectedNode: node } = React.useContext(BuilderContext);
  const { closeDrawer: cancel, saveDrawer: save } = useDrawer();
  const { state: reconsetFormState } = React.useContext(ReconsetCVMContext);

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm<ValueValidationActionType>({
    defaultValues: node?.data || {
      name: "",
      dataset: "PRIMARY",
      statusOverride: "IGNORE",
    },
    criteriaMode: "all",
    resolver: yupResolver(ValueValidationActionSchema),
  });

  return (
    <Modal centered size={"xl"} opened={true} onClose={cancel} title={<Title order={4}>Value Validation</Title>}>
      <Grid align="stretch" gutter={"xs"} mb="xs">
        <Grid.Col span={12}>
          <CTextInput
            name={`name`}
            control={control}
            showErrorText={false}
            label="Name"
            required
            disabled={node?.disabled || false}
          />
        </Grid.Col>
      </Grid>

      <Grid align="stretch" gutter={"xs"} mb="xs">
        <Grid.Col span={12}>
          <CSelect
            name={`dataset`}
            control={control}
            data={[
              { label: "Primary", value: "PRIMARY" },
              { label: "Secondary", value: "SECONDARY" },
            ]}
            showErrorText={false}
            label="Dataset"
            searchable
            clearable
            required
            disabled={node?.disabled || false}
          />
        </Grid.Col>
      </Grid>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          // borderTop: "2px solid #ccc",
          // paddingTop: "20px",
        }}
      >
        <Divider my="xs" label="Validation Conditions" labelPosition="center" />
        <Grid align="stretch" gutter={"xs"} mb="xs">
          <Grid.Col span={12}>
            <Where name={`left.where`} control={control} />
          </Grid.Col>
        </Grid>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          // borderTop: "2px solid #ccc",
          // paddingTop: "20px",
          // width: "90%",
        }}
      >
        <Divider my="xs" label="Status" labelPosition="center" />

        <Grid align="stretch" gutter={"xs"} mb="xs">
          <Grid.Col span={4}>
            <CSelect
              name={`systemStatus`}
              control={control}
              label="Status"
              data={getSystemStatus("ALL")}
              showErrorText={false}
              required
              disabled={node?.disabled || false}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <CSelect
              name={`confirmationStatus`}
              control={control}
              label="Confirmation Status"
              data={getConfirmationStatus()}
              showErrorText={false}
              required
              disabled={node?.disabled || false}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <CMultiSelect
              name={`userStatus`}
              control={control}
              label="User Status"
              data={reconsetFormState.userStatus || []}
              showErrorText={false}
              disabled={node?.disabled || false}
            />
          </Grid.Col>
        </Grid>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          // borderTop: "2px solid #ccc",
          // paddingTop: "20px",
          // width: "90%",
        }}
      >
        <Divider my="xs" label="Status Override" labelPosition="center" />

        <Grid align="stretch" gutter={"xs"} mb="xs">
          <Grid.Col span={12}>
            <CRadioGroup
              name={`statusOverride`}
              control={control}
              data={[
                { label: "Ignore", value: "IGNORE" },
                /* { label: "Override", value: "OVERRIDE" }, */
                { label: "Append", value: "APPEND" },
              ]}
              disabled={node?.disabled || false}
            />
          </Grid.Col>
        </Grid>
      </div>

      <Grid align="stretch" gutter={"xs"} mt="xs">
        <Grid.Col span={2}>
          <Button
            color="teal"
            variant="filled"
            fullWidth
            type="submit"
            onClick={
              node?.disabled
                ? () => {
                    console.log("only cancel");
                    cancel();
                  }
                : async (event: React.MouseEvent<HTMLButtonElement>) => {
                    event.preventDefault();
                    const values = getValues();
                    // console.log("values", values);
                    clearErrors();
                    try {
                      await ValueValidationActionSchema.validate(values, {
                        abortEarly: false,
                      });

                      save?.(values);
                      //cancel();
                    } catch (error) {
                      console.log("errors", error);
                      console.log("error inner", JSON.stringify(error));
                      (error as any).inner.forEach((err: any) => {
                        setError(err.path, {
                          type: "custom",
                          message: err.message,
                        });
                      });
                    }
                  }
            }
          >
            Ok
          </Button>
        </Grid.Col>
      </Grid>
    </Modal>
  );
}

export default ValueValidation;
